export const CLASS_ROOT = "megamenu";

export const CLASS_TOP = `${CLASS_ROOT}__top`;
export const CLASS_TOP_CONTENT = `${CLASS_ROOT}__top-content`;
export const CLASS_MAIN = `${CLASS_ROOT}__main`;
export const CLASS_SUBMAIN = `${CLASS_ROOT}__submain`;
export const CLASS_CONTAINER = `${CLASS_ROOT}__container`;
export const CLASS_GRID = `${CLASS_ROOT}__grid`;
export const CLASS_CARD = `${CLASS_ROOT}__card`;
export const CLASS_TILES = `${CLASS_ROOT}__tiles`;
export const CLASS_TILE = `${CLASS_ROOT}__tile`;
export const CLASS_TILE_BODY = `${CLASS_ROOT}__tile-body`;
export const CLASS_TILE_CONTENT = `${CLASS_ROOT}__tile-content`;
export const CLASS_TILE_LABEL = `${CLASS_ROOT}__tile-label`;
export const CLASS_NAV = `${CLASS_ROOT}__nav`;
export const CLASS_NAV_VERTICAL = `${CLASS_ROOT}__nav--vertical`;
export const CLASS_NAV_SPACE_SMALL = `${CLASS_ROOT}__nav--space-small`;
export const CLASS_NAV_LOCALE = `${CLASS_ROOT}__nav--locale`;
export const CLASS_NAV_MOBILE_LOCALE = `${CLASS_ROOT}__nav--mobile-locale`;
export const CLASS_NAV_ITEM = `${CLASS_ROOT}__nav-item`;
export const CLASS_NAV_ITEM_LEAD = `${CLASS_ROOT}__nav-item--lead`;
export const CLASS_NAV_ITEM_PUSH = `${CLASS_ROOT}__nav-item--push`;
export const CLASS_NAV_ITEM_MAIN = `${CLASS_ROOT}__nav-item--main`;
export const CLASS_NAV_LINK = `${CLASS_ROOT}__nav-link`;
export const CLASS_NAV_LINK_LOCALE = `${CLASS_ROOT}__nav-link--locale`;
export const CLASS_NAV_LINK_NO_LINE = `${CLASS_ROOT}__nav-link--no-line`;
export const CLASS_NAV_LINK_CTA = `${CLASS_ROOT}__nav-link--cta`;
export const CLASS_NAV_SELECT = `${CLASS_ROOT}__nav-select`;
export const CLASS_NAV_CART_ICON = `${CLASS_ROOT}__nav-cart-icon`;
export const CLASS_NAV_ICON = `${CLASS_ROOT}__nav-icon`;
export const CLASS_NAV_ICON_NO_GAP_MD_DOWN = `${CLASS_NAV_ICON}--no-gap-md-down`;
export const CLASS_NAV_ICON_CTA = `${CLASS_NAV_ICON}--cta`;
export const CLASS_NAV_LOGO = `${CLASS_ROOT}__nav-logo`;
export const CLASS_NAV_BUTTON = `${CLASS_ROOT}__nav-button`;
export const CLASS_NAV_BUTTON_INDICATOR = `${CLASS_ROOT}__nav-button--indicator`;
export const CLASS_NAV_SELECT_WRAPPER = `${CLASS_ROOT}__nav-button--select`;
export const CLASS_NAV_DROPDOWN = `${CLASS_ROOT}__nav-dropdown`;
export const CLASS_SUBNAV = `${CLASS_ROOT}__subnav`;
export const CLASS_SUBNAV_ITEM = `${CLASS_ROOT}__subnav-item`;
export const CLASS_OVERLAY = `${CLASS_ROOT}__overlay`;
export const CLASS_SPACER = `${CLASS_ROOT}-spacer`;
export const CLASS_SPACER_SMALL = `${CLASS_ROOT}-spacer--small`;

export const CLASS_TEXT_LARGE = `${CLASS_ROOT}__text--large`;
export const CLASS_CAPTION = `${CLASS_ROOT}__caption`;
export const CLASS_CAPTION_LARGE = `${CLASS_ROOT}__caption--large`;
export const CLASS_HIDE_MD_DOWN = `${CLASS_ROOT}--hide-md-down`;
export const CLASS_HIDE_LG_ONLY = `${CLASS_ROOT}--hide-lg-only`;
export const CLASS_HIDE_LG_UP = `${CLASS_ROOT}--hide-lg-up`;
export const CLASS_ALIGN_CENTER = `${CLASS_ROOT}--align-center`;

export const CLASS_MOBILE = `${CLASS_ROOT}__mobile`;
export const CLASS_MOBILE_OVERLAY = `${CLASS_ROOT}__mobile-overlay`;
export const CLASS_MOBILE_WRAPPER = `${CLASS_ROOT}__mobile-wrapper`;
export const CLASS_MOBILE_HEADER = `${CLASS_ROOT}__mobile-header`;
export const CLASS_MOBILE_BODY = `${CLASS_ROOT}__mobile-body`;
export const CLASS_MOBILE_CTA = `${CLASS_ROOT}__mobile-cta`;
export const CLASS_MOBILE_ACCOUNT = `${CLASS_ROOT}__mobile-account`;
export const CLASS_MOBILE_ACCOUNT_AVATAR = `${CLASS_ROOT}__mobile-account-avatar`;
export const CLASS_MOBILE_ACCOUNT_PHONE = `${CLASS_ROOT}__mobile-account-phone`;
export const CLASS_MOBILE_ACCOUNT_LOGOUT = `${CLASS_ROOT}__mobile-account-logout`;
export const CLASS_BUTTON = `${CLASS_ROOT}__button`;
export const CLASS_BUTTON_SECONDARY = `${CLASS_BUTTON}--secondary`;
export const CLASS_MOBILE_ACCOUNT_LINKS = `${CLASS_ROOT}__mobile-account-links`;
export const CLASS_MOBILE_ACCOUNT_LINK = `${CLASS_ROOT}__mobile-account-link`;
export const CLASS_MOBILE_APP_CARD = `${CLASS_ROOT}__mobile-app-card`;
export const CLASS_MOBILE_APP_CARD_SECTION = `${CLASS_MOBILE_APP_CARD}-section`;
export const CLASS_MOBILE_APP_CARD_TITLE = `${CLASS_MOBILE_APP_CARD}-title`;
export const CLASS_MOBILE_APP_CARD_STORES = `${CLASS_MOBILE_APP_CARD}-stores`;
export const CLASS_MOBILE_APP_CARD_STORE = `${CLASS_MOBILE_APP_CARD}-store`;
export const CLASS_MOBILE_APP_CARD_IMAGE = `${CLASS_MOBILE_APP_CARD}-image`;

// Accordion classes for mobile menu
export const CLASS_ACCORDION = `${CLASS_ROOT}__accordion`;
export const CLASS_ACCORDION_ITEM = `${CLASS_ROOT}__accordion-item`;
export const CLASS_ACCORDION_HEADER = `${CLASS_ROOT}__accordion-header`;
export const CLASS_ACCORDION_BUTTON = `${CLASS_ROOT}__accordion-button`;
export const CLASS_ACCORDION_TITLE = `${CLASS_ROOT}__accordion-title`;
export const CLASS_ACCORDION_ICON = `${CLASS_ROOT}__accordion-icon`;
export const CLASS_ACCORDION_BODY = `${CLASS_ROOT}__accordion-body`;

export const CLASS_INPUT = `${CLASS_ROOT}__input`;
export const CLASS_INPUT_WRAPPER = `${CLASS_ROOT}__input-wrapper`;
export const CLASS_INPUT_WRAPPER_SEARCH_ICON_WITH_PLACEHOLDER = `${CLASS_ROOT}__input-wrapper--search-icon-with-placeholder`;
export const CLASS_INPUT_WRAPPER_SEARCH_RESPONSIVE = `${CLASS_ROOT}__input-wrapper--search-responsive`;
export const CLASS_INPUT_SEARCH_ICON_WITH_PLACEHOLDER = `${CLASS_ROOT}__input--search-icon-with-placeholder`;
export const CLASS_INPUT_SEARCH_RESPONSIVE = `${CLASS_ROOT}__input--search-responsive`;

export const CLASS_TAG = `${CLASS_ROOT}__tag`;
export const CLASS_TAG_ORANGE = `${CLASS_ROOT}__tag--orange`;
export const CLASS_TAG_SMALL = `${CLASS_ROOT}__tag--small`;
export const CLASS_TAG_TRANSPARENT = `${CLASS_ROOT}__tag--transparent`;
export const CLASS_TAG_LARGE = `${CLASS_ROOT}__tag--large`;

export const CLASS_LIST_INLINE = `${CLASS_ROOT}__list--inline`;
export const CLASS_LIST_GAP_SMALL = `${CLASS_ROOT}__list--gap-small`;
